// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__uKKM6","skeleton_user":"Skeleton_skeleton_user__2Wt9z","img":"Skeleton_img__2xVnP","content":"Skeleton_content__wM2XR"};